import { render, staticRenderFns } from "./data-permission-config.vue?vue&type=template&id=28897c6e&scoped=true&"
import script from "./data-permission-config.vue?vue&type=script&lang=js&"
export * from "./data-permission-config.vue?vue&type=script&lang=js&"
import style0 from "./data-permission-config.vue?vue&type=style&index=0&id=28897c6e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28897c6e",
  null
  
)

export default component.exports